import { getLanguage } from "../Managers/dataProvider";
import { EnumUserAcces, ReportDetailModel } from "../Managers/dataStructures";
import { getUserAccess } from "../Managers/profileManager";

interface ReportDetailProps {
  array_reportDetail: ReportDetailModel[];
  title: string;
  date: string | undefined;
}

export default function ReportDetail(props: ReportDetailProps) {
  const isAdmin: boolean = getUserAccess() === EnumUserAcces.ADMIN;
  const isEnglish = getLanguage();
  return (
    <div className="px-2 sm:px-4 lg:px-4">
      <div className="mt-8 flow-root">
        {/* <div className="mt-5 mb-5 text-base font-semibold leading-6 text-gray-900">
          {props.title + " " + (props.date !== undefined ? props.date : "")}
        </div> */}
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table className="min-w-full divide-y divide-gray-300">
              <thead>
                <tr className="divide-x divide-gray-200">
                  <th
                    scope="col"
                    className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                  >
                    {isEnglish ? "Name" : "Name"}
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    {isEnglish ? "Employee ID" : "Mitarbeiter ID"}
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    {isEnglish ? "Start Time" : "Arbeitsbeginn"}
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    {isEnglish ? "End Time" : "Arbeitsende"}
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    {isEnglish ? "Total Hours" : "Gesamtarbeitszeit"}
                  </th>
                  {/* {isAdmin ? (
                    <th
                      scope="col"
                      className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pr-0"
                    >
                      Total Earnings
                    </th>
                  ) : null} */}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {props.array_reportDetail.map((x) =>
                  CellReportDetail(x, isAdmin)
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

function CellReportDetail(item: ReportDetailModel, isAdmin: boolean) {
  return (
    <tr className="divide-x divide-gray-200" key={item.user.user_id}>
      <td className="whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-gray-900 sm:pl-0">
        <div>
          <div>{item.user.first_name + " " + item.user.last_name}</div>
        </div>
      </td>
      <td className="whitespace-nowrap p-4 text-sm text-gray-500">
        <div>
          <div>{item.user.employee_id}</div>
        </div>
      </td>
      <td className="whitespace-nowrap p-4 text-sm text-gray-500">
        <div>
          <div> {item.start_time}</div>
        </div>
      </td>
      <td className="whitespace-nowrap p-4 text-sm text-gray-500">
        <div>
          <div> {item.end_time}</div>
        </div>
      </td>
      <td className="whitespace-nowrap p-4 text-sm text-gray-500 max-w-[200px] overflow-ellipsis overflow-clip">
        <div>
          <div> {item.working_hours}</div>
          {/* <div> {item.break_hours}</div> */}
        </div>
      </td>
      {/* {isAdmin ? (
        <td className="whitespace-nowrap py-4 pl-4 pr-4 text-sm text-gray-500 sm:pr-0">
          {getCurrentCurrency() + item.earning}
        </td>
      ) : null} */}
    </tr>
  );
}
